import styled from 'styled-components';

export const LinkStyled = styled.a`
	color: ${({ theme }) => theme.colors.quinaryColor};
	font-size: 16px;
	line-height: 27px;
	letter-spacing: 0.13px;
	font-weight: 500;
	background: ${({ theme }) => theme.colors.secondaryColor};
	padding: ${({ theme }) => theme.variables.padding * 0.5}px;
	padding-top: ${({ theme }) => theme.variables.padding * 0.25}px;
	padding-bottom: ${({ theme }) => theme.variables.padding * 0.25}px;
	display: flex;
	justify-content: space-between;
	align-items: center;
	text-decoration: none;
`;
